export default {
      id: "refresh-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.a3febc0ad2dcaff74e2f8a3b6be2fb5c.svg#refresh",
      toString: function () {
        return this.url;
      }
    }